
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export type TipoSplit = 'FIXO' | 'PERCENTUAL';

export interface SplitRecebedor {
  id: number;
  nome: string;
  walletId: string;
  ativo: boolean;
  criadoEm: string;
  atualizadoEm: string;
}

export interface SplitRecebedorRequest {
  nome: string;
  walletId: string;
  ativo: boolean;
}

export interface SplitRegra {
  id: number;
  recebedorId: number;
  nomeRecebedor: string;
  walletId: string;
  hospedagemId: number;
  tipo: TipoSplit;
  valor: number;
  ativo: boolean;
  criadoEm: string;
  atualizadoEm: string;
}

export interface SplitRegraRequest {
  recebedorId: number;
  hospedagemId: number;
  tipo: TipoSplit;
  valor: number;
  ativo: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class SplitPagamentosService {

  private http = inject(HttpClient);

  // Ajuste se o environment do projeto usar outra propriedade.
  private readonly api =
    `${environment.apiUrl}/admin/split`;

  listarRecebedores(): Observable<SplitRecebedor[]> {
    return this.http.get<SplitRecebedor[]>(
      `${this.api}/recebedores`
    );
  }

  buscarRecebedor(id: number): Observable<SplitRecebedor> {
    return this.http.get<SplitRecebedor>(
      `${this.api}/recebedores/${id}`
    );
  }

  cadastrarRecebedor(
    dto: SplitRecebedorRequest
  ): Observable<SplitRecebedor> {
    return this.http.post<SplitRecebedor>(
      `${this.api}/recebedores`,
      dto
    );
  }

  atualizarRecebedor(
    id: number,
    dto: SplitRecebedorRequest
  ): Observable<SplitRecebedor> {
    return this.http.put<SplitRecebedor>(
      `${this.api}/recebedores/${id}`,
      dto
    );
  }

  alterarStatusRecebedor(
    id: number,
    ativo: boolean
  ): Observable<void> {
    return this.http.patch<void>(
      `${this.api}/recebedores/${id}/status`,
      { ativo }
    );
  }

  listarRegrasPorRecebedor(
    recebedorId: number
  ): Observable<SplitRegra[]> {
    return this.http.get<SplitRegra[]>(
      `${this.api}/regras/recebedor/${recebedorId}`
    );
  }

  listarRegrasPorHospedagem(
    hospedagemId: number
  ): Observable<SplitRegra[]> {
    return this.http.get<SplitRegra[]>(
      `${this.api}/regras/hospedagem/${hospedagemId}`
    );
  }

  cadastrarRegra(
    dto: SplitRegraRequest
  ): Observable<SplitRegra> {
    return this.http.post<SplitRegra>(
      `${this.api}/regras`,
      dto
    );
  }

  atualizarRegra(
    id: number,
    dto: SplitRegraRequest
  ): Observable<SplitRegra> {
    return this.http.put<SplitRegra>(
      `${this.api}/regras/${id}`,
      dto
    );
  }

  alterarStatusRegra(
    id: number,
    ativo: boolean
  ): Observable<void> {
    return this.http.patch<void>(
      `${this.api}/regras/${id}/status`,
      { ativo }
    );
  }
}
